export default {"src":"/_next/static/media/DFAR.1d18df3a.svg","height":18,"width":18};